<template>
  <div
    class="modal-card"
    data-test-id="chainCreationModal"
  >
    <header class="modal-card-head">
      <b-button icon-pack="fas" icon-left="times" @click="emitClose" />
    </header>
    <section class="modal-card-body">
      <chainEdit
        @chain-update-complete="chainCreated"
        @chain-update-cancelled="emitClose"
      />
    </section>
    <footer class="modal-card-foot">
      <b-button @click="emitClose">{{ $t("Close") }}</b-button>
    </footer>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import chainEdit from '@/components/chainEdit.vue'
import shopsService from '@/services/shopsService'
import { useAppStore } from '@/stores/app'
import type { Chain } from '@/stores/app'

// Emits
const emit = defineEmits<{
  (e: 'chain-created', chain: Chain): void
  (e: 'close'): void
}>()

// Composables
const store = useAppStore()
const closeQueued = ref(false)

// Computed
const chainsList = computed(() => store.getChains)

// Methods
const emitClose = (): void => {
  if (closeQueued.value) {
    return
  }

  closeQueued.value = true
  try {
    emit('close')
  } finally {
    queueMicrotask(() => {
      closeQueued.value = false
    })
  }
}

const chainCreated = (selectedChain: Chain): void => {
  emit('chain-created', selectedChain)
  emitClose()
}

// Lifecycle
onMounted(async (): Promise<void> => {
  if (!chainsList.value) {
    await shopsService.getChains()
  }
})
</script>
